<div class="mbs-wizard_form">
  <div class="mbs-wizard_form-content">
    <mbs-form-group [formGroup]="stepForm">
      <ng-container *ngTemplateOutlet="noScheduleAlert"></ng-container>
      @if (isHybrid()) {
        <mbs-card
          class="mt-3"
          [size]="MbsSize.xs">
          @if (retentionPolicyStepLogic.storage.hybridType || retentionPolicyStepLogic.storage.hybridName) {
            <div class="mb-2">
              <span class="d-flex align-items-center text-sm fw-semibold text-black">
                <span
                  class="mbs-storage mbs-storage-sm mbs-storage_{{
                    retentionPolicyStepLogic.storage.hybridType | storageIcon: false : !retentionPolicyStepLogic.storage.hybridIsLocal
                  }} mr-2"></span>
                <mbs-text-ellipsis [tooltip]="retentionPolicyStepLogic.storage.hybridName">{{
                  retentionPolicyStepLogic.storage.hybridName
                }}</mbs-text-ellipsis>
              </span>
            </div>
          }

          <mbs-nbf-retention-policy-step-control-panel
            [isHybrid]="true"
            [isWindows]="!isUnix"
            [mode]="'hybrid'"
            [parentForm]="stepForm"
            [schedule]="retentionPolicyStepLogic.schedule"
            [storage]="retentionPolicyStepLogic.storage"
            (deleteVersionsOlderThanHybridChange)="deleteVersionsOlderThanHybridChangeHandler($event)">
          </mbs-nbf-retention-policy-step-control-panel>
        </mbs-card>
      }
      <ng-container *ngTemplateOutlet="simpleInfo"></ng-container>
      <ng-container *ngTemplateOutlet="advancedInfo"></ng-container>
      <ng-container *ngTemplateOutlet="simpleBlock"></ng-container>
      <ng-container *ngTemplateOutlet="advancedBlock"></ng-container>

      <ng-template #noScheduleAlert>
        <div
          *ngIf="retentionPolicyStepLogic.schedule.isManualMode"
          [id]="elementSelectors.id.notScheduleAlert">
          <mbs-alert
            [icon]="true"
            [type]="mbsPopupType.warning">
            {{ 'wizards:retention_policy_not_full_alert' | i18next }}
          </mbs-alert>
        </div>
      </ng-template>

      <ng-template #simpleInfo>
        <div
          *ngIf="retentionPolicyStepLogic.schedule.isSimpleMode"
          [id]="elementSelectors.id.simpleInfo">
          <mbs-card [size]="MbsSize.xs">
            <div class="row ml-n1">
              <div class="col-11">
                <strong class="d-flex align-items-center">{{ 'wizards:schedule.simpleMode.backupSchedule' | i18next }}</strong>
                <div class="d-flex align-items-center">{{ retentionPolicyStepLogic.schedule.scheduleInfo?.simple }}</div>
              </div>
              <div class="col-auto d-flex align-items-center">
                <ng-container *ngTemplateOutlet="infoTooltip"></ng-container>
              </div>
            </div>
          </mbs-card>
        </div>
      </ng-template>

      <ng-template #advancedInfo>
        <div
          *ngIf="retentionPolicyStepLogic.schedule.isAdvancedMode"
          [id]="elementSelectors.id.advancedInfo">
          <mbs-card [size]="MbsSize.xs">
            <div class="row ml-n1">
              <div class="col-11">
                <strong class="d-flex align-items-center">{{ 'wizards:schedule.advancedMode.incrementalBackupSchedule' | i18next }}</strong>
                <div
                  *ngIf="retentionPolicyStepLogic.schedule.incrementalDataEnabled"
                  class="d-flex align-items-center"
                  [id]="elementSelectors.id.advancedInfoIncrementalSchedule">
                  {{ retentionPolicyStepLogic.schedule.scheduleInfo?.incremental }}
                </div>
                <div
                  *ngIf="!retentionPolicyStepLogic.schedule.incrementalDataEnabled"
                  class="d-flex align-items-center"
                  [id]="elementSelectors.id.advancedInfoNoIncrementalSchedule">
                  {{ 'wizards:retention.advancedSchedule.disabledIncremental' | i18next }}
                </div>
                <strong class="d-flex align-items-center mt-2">{{ 'wizards:schedule.advancedMode.fullBackupSchedule' | i18next }}</strong>
                <div class="d-flex align-items-center">{{ retentionPolicyStepLogic.schedule.scheduleInfo?.full }}</div>
              </div>
              <div class="col-auto d-flex align-items-center">
                <ng-container *ngTemplateOutlet="infoTooltip"></ng-container>
              </div>
            </div>
          </mbs-card>
        </div>
      </ng-template>

      <ng-template #simpleBlock>
        <div
          *ngIf="retentionPolicyStepLogic.schedule.isSimpleMode || retentionPolicyStepLogic.schedule.isManualMode"
          [id]="elementSelectors.id.simpleBlock">
          <mbs-card
            class="mt-3"
            [size]="MbsSize.xs">
            <ng-container *ngTemplateOutlet="storageInfo"></ng-container>
            <mbs-nbf-retention-policy-step-control-panel
              [alerts]="retentionPolicyStepLogic.alerts"
              [isHybrid]="isHybrid()"
              [isWindows]="!isUnix"
              [parentForm]="stepForm"
              [schedule]="retentionPolicyStepLogic.schedule"
              [storage]="retentionPolicyStepLogic.storage"
              (retentionChange)="retentionChangeHandler()"
              (retentionUseDefaultSettingsChange)="retentionUseDefaultSettingsChangeHandler()">
            </mbs-nbf-retention-policy-step-control-panel>
          </mbs-card>
        </div>
      </ng-template>

      <ng-template #advancedBlock>
        <div
          *ngIf="retentionPolicyStepLogic.schedule.isAdvancedMode"
          [id]="elementSelectors.id.advancedBlock">
          <mbs-card
            class="mt-3"
            [size]="MbsSize.xs">
            <mbs-card-group>
              <ng-container *ngTemplateOutlet="storageInfo"></ng-container>
              <mbs-nbf-retention-policy-step-control-panel
                [alerts]="retentionPolicyStepLogic.alerts"
                [GFSInfo]="retentionPolicyStepLogic.GFSInfo"
                [isHybrid]="isHybrid()"
                [isWindows]="!isUnix"
                [parentForm]="stepForm"
                [schedule]="retentionPolicyStepLogic.schedule"
                [storage]="retentionPolicyStepLogic.storage"
                (clickDetailsGFS)="clickDetailsGFS()"
                (GFSEnabledChange)="GFSEnabledChangeHandler()"
                (retentionChange)="retentionChangeHandler()"
                (retentionUseDefaultSettingsChange)="retentionUseDefaultSettingsChangeHandler()">
              </mbs-nbf-retention-policy-step-control-panel>
            </mbs-card-group>
          </mbs-card>
        </div>
      </ng-template>

      <ng-template #infoTooltip>
        <span
          class="fa fa-info-circle ml-2 cursor-help text-info"
          container="body"
          tooltipClass="tooltip-lg"
          [closeDelay]="1000"
          [ngbTooltip]="simpleInfoTooltip"></span>
        <ng-template #simpleInfoTooltip>
          {{ 'wizards:retention.infoTooltip' | i18next }}.&nbsp;
          <a
            *ngIf="ability.can('read', 'HelpMarketing')"
            class="ml-2"
            href="/AP/Help/backup/file/nbf#9"
            target="_blank">
            {{ 'shared:buttons.learnMore' | i18next }}
          </a>
        </ng-template>
      </ng-template>
    </mbs-form-group>
  </div>
</div>

<ng-template #storageInfo>
  <mbs-retention-policy-storage-info
    [storage]="retentionPolicyStepLogic.storage"
    [storageHasObjectLocke2e]="elementSelectors.id.storageHasObjectLock"></mbs-retention-policy-storage-info>
</ng-template>
